import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { SpeakerHigh, SealCheck, Play, Pause } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";

export default function Doa() {
  const [doa, setDoa] = useState([]);
  const [playing, setPlaying] = useState(null);
  const audioRef = useRef(null);
  useEffect(() => { api.get("/content/doa").then((r) => setDoa(r.data)); return () => stop(); }, []);

  const stop = () => { if (audioRef.current) { audioRef.current.pause(); audioRef.current = null; } setPlaying(null); };
  const toggle = (d) => {
    if (playing === d.id) { stop(); return; }
    stop();
    const a = new Audio(d.audio);
    a.onended = () => setPlaying(null);
    a.play().catch(() => {});
    audioRef.current = a; setPlaying(d.id);
  };
  const speak = (text) => {
    try {
      const u = new SpeechSynthesisUtterance(text);
      u.lang = "ar-SA";
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(u);
    } catch (e) {}
  };

  return (
    <div>
      <PageHeader title="Doa Harian" />
      <div className="px-5 pt-4 space-y-4">
        {doa.map((d, i) => (
          <motion.div
            key={d.id || i}
            data-testid={`doa-${i}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            className="bg-white rounded-3xl border border-stone-200/60 p-5 shadow-sm"
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-heading font-bold text-primary">{d.label}</h3>
              {d.audio ? (
                <button data-testid={`doa-audio-${i}`} onClick={() => toggle(d)}
                  className="w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center active:scale-90 transition-transform">
                  {playing === d.id ? <Pause size={18} weight="fill" /> : <Play size={18} weight="fill" />}
                </button>
              ) : (
                <button data-testid={`doa-tts-${i}`} onClick={() => speak(d.arabic)}
                  className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center active:scale-90 transition-transform">
                  <SpeakerHigh size={18} weight="fill" className="text-primary" />
                </button>
              )}
            </div>
            <p className="font-arabic text-3xl leading-loose text-right text-stone-800 mb-3">{d.arabic}</p>
            <p className="text-primary/80 italic text-sm mb-2">{d.latin}</p>
            <p className="text-stone-600 text-sm leading-relaxed border-t border-stone-100 pt-2">{d.translation}</p>
            {d.source && (
              <p data-testid={`doa-source-${i}`} className="text-[11px] font-semibold text-primary/80 mt-2.5 inline-flex items-center gap-1 bg-primary/10 px-2.5 py-1 rounded-full">
                <SealCheck size={13} weight="fill" /> Shahih • {d.source}
              </p>
            )}
          </motion.div>
        ))}
        {doa.length === 0 && <p className="text-center text-stone-400 mt-10">Belum ada doa.</p>}
      </div>
    </div>
  );
}
